<template>
  <b-row>
    <b-col sm="12">

      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
          </div>
        </section>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-table class="mb-0 app-table crud-php-callback-table"
                    responsive="sm"
                    ref="table"
                    :stacked="isMobileViewport ? 'md' : false"
                    sticky-header="60vh"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    selectable
                    select-mode="single"
                    v-if="table.items.length">

                <template v-slot:cell(id)="data">
                  <b>{{data.item.id}}</b>
                </template>

                <template v-slot:cell(blocked)="data">
                  <AppIcon name="lock" v-if="data.item.blocked" v-b-tooltip.hover title="Bloqueado" />
                </template>

                <template v-slot:cell(name)="data">
                  {{data.item.name}}
                </template>

                <template v-slot:cell(observations)="data">
                  <div v-if="data.item.observations">
                    <div v-if="data.item.observations.length >50" :title="data.item.observations">
                      <AppIcon name="chat-square-text" class="mr-1" font-scale="1.2" />
                      {{data.item.observations.substr(0, 150)}}
                    </div>
                    <div v-else>
                      {{data.item.observations}}
                    </div>
                  </div>
                </template>

                <template v-slot:cell(log_url)="data">
                  <b-link :href="getLogUrl(data.item)" target="_blank" v-if="isMobileViewport">
                    <AppIcon name="clock-history" class="mr-1" />Ver log
                  </b-link>
                  <b-link :href="getLogUrl(data.item)" target="_blank" v-else v-b-tooltip.hover.right title="Ver log">
                    <AppIcon name="clock-history" />
                  </b-link>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-php-callback-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>

                    <b-dropdown-item @click="openCode(data.item)">
                      <AppIcon name="data_object" /> Código
                    </b-dropdown-item>

                    <b-dropdown-header>Log</b-dropdown-header>
                    <b-dropdown-item @click="openLog(data.item)">
                      <AppIcon name="visibility" /> Ver
                    </b-dropdown-item>
                    <b-dropdown-item @click="deleteLog(data.item)">
                      <AppIcon name="eraser-fill" class="text-danger" /> Vaciar
                    </b-dropdown-item>

                    <b-dropdown-header>Protección</b-dropdown-header>
                    <b-dropdown-item @click="blockedPHP(data.item)" v-if="!data.item.blocked">
                      <AppIcon name="lock-fill" /> Bloquear
                    </b-dropdown-item>
                    <b-dropdown-item @click="unlockedPHP(data.item)" v-else>
                      <AppIcon name="lock-fill" /> Desbloquear
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else title="No se encontraron registros" />
          </b-col>
        </b-row>
      </b-card>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" class="mr-1" />Volver
          </b-button>
        </div>
      </b-card>

    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import moment from 'moment'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PHP,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudPHPCallback',
          elements: {}
        },
        table : {
          items: [],
          fields: [],
        },
        constant: {
          type: 'callback'
        },
        isMobileViewport: false,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.loadFieldTable()
      this.load()
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    watch: {
      isMobileViewport() {
        this.loadFieldTable()
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      loadFieldTable() {
        this.table.fields = []
        this.table.fields.push({key: 'id', label: 'ID', sortable: true, class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'blocked', label: 'Bloqueado', class: "align-middle " + this.alignClass('text-center')})
        this.table.fields.push({key: 'name', label: 'Nombre', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'observations', label: 'Observaciones', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'log_url', label: 'LOG', class: "align-middle " + this.alignClass('text-center')})
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: "align-middle " + this.alignClass('text-right'), width: "60px"})
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      getRowCount (items) {
        return items.length
      },
      load() {
        var result = serviceAPI.obtenerPHP(this.constant.type)

        result.then((response) => {
          var data = response.data
          this.table.items = data

          this.table.items.forEach(element => {
            if(!element.blocked) {
              element._rowVariant = 'danger'
            }
          });

          if(this.$refs.table) {
            this.$refs.table.$forceUpdate()
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });
      },
      getLogUrl(item) {
        return item.log_url + Session.getToken()
      },
      openCode(item) {
        this.$router.push({ name: 'PHPStaffCrudPHPCode', params: {id: item.id}  })
      },
      blockedPHP(item) {
        this.confirmDialog('¿Desea bloquear el bloque de código (' + item.name + ')?', {
          title: 'Bloquear código',
          icon: 'lock-fill',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var params = {
              id: item.id,
              blocked: true
            }

            var result = serviceAPI.guardarBlockedPHP(params);

            result.then((response) => {
              loader.hide()
              this.load()
              this.$awn.success("Código bloqueado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      unlockedPHP(item) {
        this.confirmDialog('¿Desea desbloquear el bloque de código (' + item.name + ')?', {
          title: 'Desbloquear código',
          icon: 'unlock',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var params = {
              id: item.id,
              blocked: false
            }

            var result = serviceAPI.guardarBlockedPHP(params);

            result.then((response) => {
              loader.hide()
              this.load()
              this.$awn.success("Código desbloqueado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      openLog(item) {
        const url = this.getLogUrl(item);
        window.open(url, '_blank');
      },
      deleteLog(item) {
        var result = serviceAPI.eliminarPHPLog(item.id);

        result.then((response) => {
          this.$awn.success(response.data);
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
    }
  }
</script>
<style>
  /* Kebab con texto "Opciones" visible en mobile (ABM sin drawer: la única
     forma de llegar a Código/Log/Bloquear/Editar/Eliminar es esta acción,
     no puede quedar muda ni oculta). Alineado a la izquierda, como el resto
     del valor apilado. */
  .btn.crud-php-callback-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
    white-space: nowrap;
  }
  .btn.crud-php-callback-action-toggle-labeled:hover,
  .btn.crud-php-callback-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .crud-php-callback-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }
</style>
